import React from 'react';
import { Annotation } from '@/types/Annotation.model';

interface AnnotationHotspotProps {
  annotation: Annotation;
  onClick: (annotation: Annotation, event: React.MouseEvent) => void;
}

/**
 * Reusable component for annotation hotspot buttons
 * Displays a pill-shaped button that grows with the annotation label (number or text)
 * Used in model-viewer to mark annotation positions
 */
export function AnnotationHotspot({ annotation, onClick }: AnnotationHotspotProps) {
  return (
    <button
      key={annotation.id}
      slot={`hotspot-${annotation.id}`}
      onClick={(e) => onClick(annotation, e.nativeEvent as any)}
      style={{
        minWidth: '22px',
        minHeight: '22px',
        padding: '3px 8px',
        width: 'max-content',
        height: 'auto',
        borderRadius: '9999px',
        border: '1px solid #ffffff',
        background: 'rgba(15, 23, 42, 0.9)',
        color: '#ffffff',
        fontSize: '11px',
        fontWeight: 600,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        transform: 'translate3d(-50%, -50%, 0)',
        boxShadow: '0 1px 4px rgba(0,0,0,0.35)',
        whiteSpace: 'nowrap',
      }}
      data-position={annotation.position}
      {...(annotation.normal ? { 'data-normal': annotation.normal } : {})}
    >
      {annotation.label}
    </button>
  );
}
